import ApiDocs from '../../../../../components/api-docs/api-docs';

export default function ApiDocsSystemAdministratorOfficeScreen() {
  return <ApiDocs />;
}
